import { AlertTriangle } from "lucide-react";
import { fmtDateTime } from "@/lib/time";

export const PendingWarning = ({ pending, ack, onAck, testid }) => {
  if (!pending?.length) return null;
  return (
    <div className="rounded-md border border-amber-500/30 bg-amber-500/10 px-3 py-2.5 text-xs text-amber-100" data-testid={testid}>
      <p className="flex items-center gap-1.5 font-semibold text-amber-300">
        <AlertTriangle className="h-3.5 w-3.5" /> This driver has {pending.length} unfinished earlier trip{pending.length === 1 ? "" : "s"}
      </p>
      <ul className="mt-1.5 space-y-0.5 text-amber-200/90">
        {pending.slice(0, 4).map((t) => (
          <li key={t.id} className="font-mono-data text-[11px]">{t.external_trip_id} · {fmtDateTime(t.scheduled_pickup)} · {t.status}</li>
        ))}
        {pending.length > 4 && <li className="text-[11px]">+{pending.length - 4} more</li>}
      </ul>
      <label className="mt-2 flex cursor-pointer items-center gap-2 text-amber-100">
        <input type="checkbox" checked={ack} onChange={(e) => onAck(e.target.checked)} className="h-3.5 w-3.5 accent-amber-500" data-testid={`${testid}-ack`} />
        Add this trip to their list anyway
      </label>
    </div>
  );
};
